<script setup lang="ts">
import { useSearchPopupStore } from '~/store/search-popup'

const searchPopupStore = useSearchPopupStore()
</script>

<template>
  <div class="w-full h-full">
    <div class="hidden fixed inset-0 z-[101] md:block md:bg-main-dark/50" @click.self="searchPopupStore.close" />
    <div
      id="popup-modal"
      class="
        custom-scroll absolute left-0 right-0 top-[58px] z-[102] -mx-4 my-0 h-[calc(100vh-155px)] w-[calc(100%+2rem)]
        min-w-[280px] overflow-y-scroll bg-main-gray-low p-4 pb-0
        sm:min-w-[470px]
        md:left-1/2 md:-translate-x-1/2 md:mx-0 md:h-auto md:max-h-[80vh] md:overflow-y-auto md:rounded-xl md:w-full
        md:bg-main-gray-low md:p-7 md:pb-0
        lg:left-0 lg:transform-none
      "
    >
      <slot />

      <div class="mb-48 md:mb-0"></div>
    </div>
  </div>
</template>
